module.exports = __webpack_public_path__ + "img/mobile/General/spelpaus@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/General/spelpaus@1x.png
// module id = 187
// module chunks = 0